import React from "react";
import {Card, Collapse, Col,Row} from "antd";


const Panel = Collapse.Panel;


const FAQ = () => {
  const callback = (key) => {
    console.log(key);
  };

  return (
      <>
      <Row justify="center" style={{marginTop:40}} >
          <Col lg={12}  >
              <div  style={{ "-webkit-text-align": "center", "text-align": "center" }}>
              <h1>
                 Start now with these 3 Simple Steps</h1>
              </div>
              
              </Col>
      </Row>
      <Row justify="center" style={{marginTop:10}}>
          
          <Col lg={4}>
              <div className="wpb_wrapper"  style={{  "padding":"20px", "-webkit-text-align": "center", "text-align": "center" }}>
                  <div className="wpb_single_image wpb_content_element vc_align_center">
                      <figure className="wpb_wrapper vc_figure">
                          <div className="vc_single_image-wrapper   vc_box_border_grey">
                              <img width={150} height={150} src="https://quiznext.in/wp-content/uploads/2020/06/1-150x150.png" className="vc_single_image-img attachment-thumbnail" alt srcSet="https://quiznext.in/wp-content/uploads/2020/06/1-150x150.png 150w, https://quiznext.in/wp-content/uploads/2020/06/1-300x300.png 300w, https://quiznext.in/wp-content/uploads/2020/06/1-768x768.png 768w, https://quiznext.in/wp-content/uploads/2020/06/1-1024x1024.png 1024w, https://quiznext.in/wp-content/uploads/2020/06/1-60x60.png 60w, https://quiznext.in/wp-content/uploads/2020/06/1.png 1080w" sizes="(max-width: 150px) 100vw, 150px" /></div>
                      </figure>
                  </div>
                  <div className="wpb_text_column wpb_content_element "  style={{ "-webkit-text-align": "center", "text-align": "center" }}>
                      <div className="wpb_wrapper">
                          <h2 style={{ "-webkit-text-align": "center", "text-align": "center" }}>Assign a Quiz</h2>
                          <p style={{ "-webkit-text-align": "center", "text-align": "center" }}>Assign a Quiz in just 2 minutes. Pick your class, select the chapter and assign. You get to <span>choose from over 3 lakh free expert-created quizzes. </span></p>
                      </div>
                  </div>
              </div>
          </Col>
          <Col  lg={4}>
              <div className="wpb_wrapper"  style={{  "padding":"20px" ,"-webkit-text-align": "center", "text-align": "center" }}>
                  <div className="wpb_single_image wpb_content_element vc_align_center">
                      <figure className="wpb_wrapper vc_figure">
                          <div className="vc_single_image-wrapper   vc_box_border_grey"><img width={150} height={150} src="https://quiznext.in/wp-content/uploads/2020/06/2-150x150.png" className="vc_single_image-img attachment-thumbnail" alt srcSet="https://quiznext.in/wp-content/uploads/2020/06/2-150x150.png 150w, https://quiznext.in/wp-content/uploads/2020/06/2-300x300.png 300w, https://quiznext.in/wp-content/uploads/2020/06/2-768x768.png 768w, https://quiznext.in/wp-content/uploads/2020/06/2-1024x1024.png 1024w, https://quiznext.in/wp-content/uploads/2020/06/2-60x60.png 60w, https://quiznext.in/wp-content/uploads/2020/06/2.png 1080w" sizes="(max-width: 150px) 100vw, 150px" /></div>
                      </figure>
                  </div>
                  <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                          <h2 style={{ "-webkit-text-align": "center", "text-align": "center" }}>Students engage</h2>
                          <p style={{ "-webkit-text-align": "center", "text-align": "center" }}>Students complete the quiz at their own pace while at home. The quiz format and game elements make practice more fun for students.</p>
                      </div>
                  </div>
              </div>
          </Col>
          <Col  lg={4}>
          <div className="wpb_wrapper" style={{ "-webkit-text-align": "center", "text-align": "center" , "padding":"20px"}}>
                  <div className="wpb_single_image wpb_content_element vc_align_center"   >
                      <figure className="wpb_wrapper vc_figure">
                          <div className="vc_single_image-wrapper   vc_box_border_grey"><img width={150} height={150} src="https://quiznext.in/wp-content/uploads/2020/06/3-150x150.png" className="vc_single_image-img attachment-thumbnail" alt srcSet="https://quiznext.in/wp-content/uploads/2020/06/3-150x150.png 150w, https://quiznext.in/wp-content/uploads/2020/06/3-300x300.png 300w, https://quiznext.in/wp-content/uploads/2020/06/3-768x768.png 768w, https://quiznext.in/wp-content/uploads/2020/06/3-1024x1024.png 1024w, https://quiznext.in/wp-content/uploads/2020/06/3-60x60.png 60w, https://quiznext.in/wp-content/uploads/2020/06/3.png 1080w" sizes="(max-width: 150px) 100vw, 150px" /></div>
                      </figure>
                  </div>
                  <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                          <h2 style={{ "-webkit-text-align": "center", "text-align": "center" }}>Get insights</h2>
                          <p style={{ "-webkit-text-align": "center", "text-align": "center" }}>Get students reports in real-time. Spend zero- minutes on grading. We will tell you what students practised and what they know.</p>
                      </div>
                  </div>
</div>
          </Col>
    <Col  lg={16} style={{marginTop:40}}>
    <Card className="gx-card ant-empty-footer" title="Frequently Asked Questions">
      <Collapse defaultActiveKey={['1']} onChange={callback}>
        <Panel header="Can I signup as a Teacher or should I approach through management?" key="1">
          <p>We validated if you are an authorized person or a teacher from the school so that student data can be made available. Since there are no contracts to be signed from school, any teacher can sign up for QuizNext and can be used at individual teacher level. Most of the time, its individual teachers who are enthusiastic and innovative who signs up first.</p>
        </Panel>
        <Panel header="Does it come with a Question bank or I need to upload my content?" key="2">
          <p>We have more than 3Lakh questions across the courses in the form of Quizzess, Active notes and Assessments. So you can start using it without the need of uploading your own content. In case you want to create your own content, you are welcome to do so.</p>
        </Panel>
        <Panel header="What device do I need?" key="3">
          <p>QuizNext Classroom is a web portal and can be accessed by any device including Laptop, Tablet and Mobile Phones. However, students need either an Android device or an iOS device to attempt these assignments.</p>
        </Panel>
        <Panel header="Is it completely free?" key="4" >
          <p>Yes. As a teacher, you can assign unlimited practices to your students at ZERO cost for ever. There are no limitations or hidden features for which you/school need to pay.</p>
        </Panel>
        <Panel header="If its free, What is the catch?" key="5" >
          <p>There is no catch. You can use as long as you want without paying any rupee. However, If you need any customization that is specific to your school, we may ask you to pay for it. Student version of QuizNext, offers Personalized Practice experience and much more features. If students or parents wants to avail these premium features, they can upgrade to the premium version. Again, to complete the assignments from school, students need not have to pay.  </p>
        </Panel>
      </Collapse>
    </Card>
    </Col>
    </Row>
    </>
  );
};

export default FAQ;
